import type {Validator} from '@github-ui/safe-indexed-db-storage'

export function createServerPersistedQueryValidator(queryHash: string): Validator {
  return {
    // Validation comes from the server-persisted query hash. If the query changes the hash changes,
    // which makes data cached for the previous response shape unreachable.
    Check(value: unknown) {
      return typeof value === 'object' && value !== null
    },
    Code() {
      return `server-persisted-query:${queryHash}`
    },
    Errors() {
      return []
    },
  }
}
